import { useState } from 'react'

import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { loadAllTimeRecords } from './exportAllTimeRecords'
import {
  AllTimesHeaderLabels,
  exportAllTimesToCSV,
} from './exportAllTimesToCSV'
import { FilterValues, WeekRange } from '../../types'

const ISO_DATE = 'yyyy-MM-dd'

type ExportAllTimesParams = {
  filters: FilterValues
  weekRange: WeekRange
}

type UseExportAllTimes = {
  isExporting: boolean
  exportCSV: () => Promise<void>
}

export const useExportAllTimes = ({
  filters,
  weekRange,
}: ExportAllTimesParams): UseExportAllTimes => {
  const [isExporting, setIsExporting] = useState(false)
  const { t } = useTranslation()

  const exportCSV = async () => {
    setIsExporting(true)
    try {
      const records = await loadAllTimeRecords({
        appliedFilters: filters,
        weekRange,
      })
      const rangeLabel = `${format(new Date(weekRange.startDate), ISO_DATE)}_${format(new Date(weekRange.endDate), ISO_DATE)}`
      const headerLabels: AllTimesHeaderLabels = {
        date: t('timeTracking.columns.date'),
        teamMember: t('timeTracking.columns.teamMember'),
        client: t('timeTracking.allTimesExport.client'),
        order: t('timeTracking.form.order'),
        position: t('timeTracking.allTimesExport.position'),
        description: t('timeTracking.form.description'),
        internalNote: t('timeTracking.allTimesExport.internalNote'),
        tracked: t('timeTracking.billing.tracked'),
        billable: t('timeTracking.billing.billable'),
        nonBillable: t('timeTracking.billing.nonBillable'),
        status: t('timeTracking.columns.status'),
      }
      exportAllTimesToCSV({ records, rangeLabel, headerLabels })
    } finally {
      setIsExporting(false)
    }
  }

  return { isExporting, exportCSV }
}
